// extracted by mini-css-extract-plugin
export default {"semiTitle":"item_semiTitle__CQsWw","lineButtons":"item_lineButtons__BMZc8","headers":"item_headers__+gq7a","twoInLine":"item_twoInLine__tBQfe","blokInputs":"item_blokInputs__a-fxt"};